import client from "./requestclient";

export const registerTenant = async tenantPayload => {
  return await client({
    URL_PATH: "realtortenantreferrer",
    method: "POST",
    body: tenantPayload
  });
};
